import React from 'react';
import Button from '../Button';
import Money from '../../../../components/Money';

var PaymentAmountSelector = function PaymentAmountSelector(_ref) {
  var amounts = _ref.amounts,
      _onClick = _ref.onClick,
      currency = _ref.currency,
      disabled = _ref.disabled,
      buttonLoading = _ref.buttonLoading,
      setButtonLoading = _ref.setButtonLoading;
  return React.createElement(
    'div',
    { className: 'amount-selector' },
    amounts.map(function (amount, i) {
      var buttonName = 'quick-amount-button' + i;

      return React.createElement(
        Button,
        {
          className: 'button secondary',
          isLoading: buttonLoading === buttonName,
          disabled: disabled || buttonLoading === buttonName,
          onClick: function onClick() {
            setButtonLoading(buttonName);
            _onClick({ amount: amount });
          },
          type: 'button',
          key: i },
        React.createElement(Money, {
          value: amount,
          currency: currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
      );
    })
  );
};

export default PaymentAmountSelector;